type ProvidingPageState = {
  pageColor?: string
  hasBackground?: boolean
}

type PageColor = 'blue' | 'green'

export default function (props?: ProvidingPageState) {
  const pageColor = computed<PageColor>(() => {
    if (props?.pageColor === 'green') {
      return 'green'
    }

    return 'blue'
  })

  const hasBackground = computed<boolean>(() => !!props?.hasBackground)

  const htmlClasses = computed(() => {
    const v: string[] = []

    if (hasBackground.value) {
      v.push('has-highlighted-hero')
    }

    if (pageColor.value === 'blue') {
      v.push('has-highlight-primary')
    } else {
      v.push('has-highlight-secondary')
    }

    return v
  })

  return { hasBackground, htmlClasses }
}
